import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs} from "../../../AbstractElements";
import ApplicationTable from "../../DataTables/Applications/ApplicationTable";

const CancelledApplicationsContainer = () => {
    const ApplStatus = "10";
    const Title = "Cancelled Applications";
    const Desc = "Displays all applications that have been marked as cancelled during the recruitment process. This module provides a consolidated view of cancelled application records, including applicant details, applied positions, cancellation dates, and current application status for monitoring, auditing, and reference purposes.";
    return (
        <>
        <Breadcrumbs mainTitle="Cancelled Applications" parent="Application Forms" />
        <Container fluid>
            <Row>
                <Col sm="12">
                    <Card>
                        <CardBody>
                            <ApplicationTable 
                            ApplStatus={ApplStatus} 
                            Title={Title} 
                            Desc={Desc}
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
        </>
    );
};

export default CancelledApplicationsContainer;
